<template>
  <div class="alert-card" :class="`alert-card--${severity.toLowerCase()}`">
    <button class="alert-card__dismiss" @click="$emit('dismiss')" aria-label="Descartar">
      <span class="mdi mdi-close"></span>
    </button>

    <div class="alert-card__header">
      <span class="mdi alert-card__module-icon" :class="MODULE_ICONS[module]"></span>
      <span class="alert-card__elapsed">{{ elapsedLabel }}</span>
    </div>

    <span class="alert-card__title">{{ title }}</span>
    <span class="alert-card__detail">{{ detail }}</span>

    <button class="alert-card__action" @click="$emit('action')">{{ actionLabel }}</button>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  severity: String,
  module: String,
  title: String,
  detail: String,
  actionLabel: String,
  since: [String, Date],
})

defineEmits(['action', 'dismiss'])

const MODULE_ICONS = {
  contracts: 'mdi-file-document-outline',
  finance: 'mdi-cash-multiple',
  maintenance: 'mdi-wrench-outline',
  services: 'mdi-cog-outline',
  whatsapp: 'mdi-whatsapp',
}

const elapsedLabel = computed(() => {
  const sinceDate = new Date(props.since)
  const diffMs = Date.now() - sinceDate.getTime()
  const hours = Math.floor(diffMs / (1000 * 60 * 60))
  if (hours < 1) return 'Ahora'
  if (hours < 24) return `${hours}h`
  return `${Math.floor(hours / 24)}d`
})
</script>

<style scoped>
.alert-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  border-left: 3px solid transparent;
  padding: 0.6rem 1.3rem 0.6rem 0.65rem;
}

.alert-card--critical { border-left-color: var(--accent-red); }
.alert-card--warning { border-left-color: var(--accent-amber); }
.alert-card--info { border-left-color: var(--accent-blue); }

.alert-card__dismiss {
  position: absolute;
  top: 0.35rem;
  right: 0.35rem;
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 0.72rem;
  padding: 0.15rem;
  line-height: 1;
}

.alert-card__dismiss:hover {
  color: var(--text-content);
}

.alert-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.alert-card__module-icon {
  color: #64748b;
  font-size: 0.8rem;
}

.alert-card__elapsed {
  font-size: 0.58rem;
  color: #94a3b8;
  white-space: nowrap;
}

.alert-card__title {
  font-size: 0.68rem;
  font-weight: 600;
  color: var(--text-content);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.alert-card__detail {
  font-size: 0.63rem;
  color: #64748b;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.alert-card__action {
  align-self: center;
  background: #eef2f7;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: var(--text-content);
  font-size: 0.68rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0.32rem 0.85rem;
  margin-top: 0.15rem;
  transition: background 0.15s ease;
}

.alert-card__action:hover {
  background: #e2e8f0;
}
</style>